import { render, staticRenderFns } from "./ToolbarMain.vue?vue&type=template&id=7a96fd40"
import script from "./ToolbarMain.vue?vue&type=script&lang=js"
export * from "./ToolbarMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports